import React from "react";
import styled from "styled-components";
import CustomDoubleTitle from "../General/CustomDoubleTitle";
import { Table } from "antd";

const CompareSectionContainer = styled.div`
  width: 100%;
  background-color: #000e14;
  padding: 40px 0;
`;

const CompareSectionInnerContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;

  @media only screen and (max-width: 1430px) {
    max-width: 1250px;
  }
`;

const CompareSectionContentWrapper = styled.div`
  padding: 0;

  @media only screen and (max-width: 1280px) {
    padding: 0 10px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 30px;
  }

  @media only screen and (max-width: 942px) {
    padding: 0 15px;
  }
`;

const CompareTableWrapper = styled.div`
  padding: 40px 0;

  & .ant-table-wrapper .ant-table-thead > tr > th {
    background-color: #000e14;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    border-bottom: 1px solid #0b3e40;
    padding: 30px 16px;
  }

  & .ant-table-wrapper .ant-table-tbody > tr > td {
    background-color: #000e14;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    width: fit-content;
    border-bottom: 1px solid #0b3e40;
    padding: 30px 16px;
  }

  & .ant-table-wrapper .ant-table-tbody > tr > td:not(:first-child) {
    font-size: 12px;
    line-height: 16px;
  }

  & .ant-table-cell-row-hover {
    background-color: #000e14 !important;
  }

  & .ant-table-content {
    -ms-overflow-style: none !important; /* Internet Explorer 10+ */
    scrollbar-width: none !important; /* Firefox */

    & .ant-table-content::-webkit-scrollbar {
      display: none !important; /* Safari and Chrome */
      width: 0px !important;
      background: transparent !important; /* make scrollbar transparent */
    }
  }

  &
    .ant-table-wrapper
    .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    display: none;
  }
`;

const TextTableSpan = styled.span`
  padding: 3px 8px;
  border-radius: 4px;
  background-color: #062223;
`;

const CompareSection = () => {
  return (
    <CompareSectionContainer>
      <CompareSectionInnerContainer>
        <CompareSectionContentWrapper>
          <CustomDoubleTitle
            firstTitle={"COMPARISON"}
            secondTitle={"How do we compare?"}
          />

          <CompareTableWrapper>
            <Table
              pagination={false}
              scroll={{ x: "max-content" }}
              columns={[
                {
                  title: "",
                  dataIndex: "feature",
                  key: "feature",
                  width: "125px",
                },
                {
                  title: "FREELANCE ❌",
                  dataIndex: "freelance",
                  key: "freelance",
                  width: "150px",
                  render: (value) => {
                    return <TextTableSpan>{value}</TextTableSpan>;
                  },
                },
                {
                  title: "IN-HOUSE ❌",
                  dataIndex: "inhouse",
                  key: "inhouse",
                  width: "150px",
                  render: (value) => {
                    return <TextTableSpan>{value}</TextTableSpan>;
                  },
                },
                {
                  title: "AGENCY ❌",
                  dataIndex: "agency",
                  key: "agency",
                  width: "150px",
                  render: (value) => {
                    return <TextTableSpan>{value}</TextTableSpan>;
                  },
                },
                {
                  title: "OUR COMPANY ✅",
                  dataIndex: "company",
                  key: "company",
                  width: "180px",
                  render: (value) => {
                    return <TextTableSpan>{value}</TextTableSpan>;
                  },
                },
              ]}
              dataSource={[
                {
                  key: "1",
                  feature: "Monthly cost",
                  freelance: "$7,000+",
                  inhouse: "$10,000+",
                  agency: "$7,000+",
                  company: "$6,900/mo",
                },
                {
                  key: "2",
                  feature: "Time to hire",
                  freelance: "Days/weeks",
                  inhouse: "Weeks/months",
                  agency: "Weeks/months",
                  company: "A few hours!",
                },
                {
                  key: "3",
                  feature: "Skill level",
                  freelance: "Novice or junior",
                  inhouse: "Good (hopefully)",
                  agency: "Rolling the dice",
                  company: "COO-level!",
                },
                {
                  key: "4",
                  feature: "First delivery",
                  freelance: "Several weeks",
                  inhouse: "Several weeks",
                  agency: "Several weeks",
                  company: "2-3 days!",
                },
                {
                  key: "5",
                  feature: "Significant",
                  freelance: "Severance + headache",
                  inhouse: "$7,000+",
                  agency: "Significant",
                  company: "One click + $0!",
                },
              ]}
            />
          </CompareTableWrapper>
        </CompareSectionContentWrapper>
      </CompareSectionInnerContainer>
    </CompareSectionContainer>
  );
};

export default CompareSection;
